import { render, staticRenderFns } from "./AvatarBuilderTraitPreview.vue?vue&type=template&id=c22cddc0&scoped=true&"
import script from "./AvatarBuilderTraitPreview.vue?vue&type=script&lang=js&"
export * from "./AvatarBuilderTraitPreview.vue?vue&type=script&lang=js&"
import style0 from "./AvatarBuilderTraitPreview.vue?vue&type=style&index=0&id=c22cddc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22cddc0",
  null
  
)

export default component.exports